(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');
var header=document.getElementById('site-header');
if(!drawer||!header)return;

function isOpen(){
  return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false';
}
function setHeaderHeight(){
  var h=Math.ceil(header.getBoundingClientRect().height||0);
  if(h>0)document.documentElement.style.setProperty('--psi-cart-site-header-h',h+'px');
}
function syncChrome(){
  if(isOpen()){
    setHeaderHeight();
    document.body.classList.add('psi-cart-v411-open');
  }else{
    document.body.classList.remove('psi-cart-v411-open');
    document.documentElement.style.removeProperty('--psi-cart-site-header-h');
  }
}
function closeCart(){
  var close=drawer.querySelector('#cart-close');
  if(close)close.click();
}

new MutationObserver(syncChrome).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
window.addEventListener('resize',function(){if(isOpen())setHeaderHeight()},{passive:true});
window.addEventListener('orientationchange',function(){if(isOpen())setHeaderHeight()},{passive:true});
if(window.ResizeObserver){
  new ResizeObserver(function(){if(isOpen())setHeaderHeight()}).observe(header);
}

document.addEventListener('click',function(e){
  if(!isOpen()||!e.target||!e.target.closest)return;

  var cartToggle=e.target.closest('#site-header #cart-toggle');
  if(cartToggle){
    e.preventDefault();
    e.stopImmediatePropagation();
    closeCart();
    return;
  }

  var headerAction=e.target.closest('#site-header a,#site-header #search-toggle,#site-header #psi-burger');
  if(headerAction)closeCart();
},true);

syncChrome();
}());
